<template>
  <DashboardPage>
    <LotForm :id="route.params.id" />
  </DashboardPage>
</template>
  
<script setup>
import { useRoute } from 'vue-router';

import DashboardPage from '@/components/DashboardPage.vue'

import LotForm from './components/LotForm.vue';

const route = useRoute()
</script>